module.exports = __webpack_public_path__ + "img/card4-bl3.a049444d.svg";